export const documentMixin = {
    data() {
        return {
            typeDocs: [
                { value: 0, text: "Geen" },
                { value: 1, text: "p.a. Factuur" },
                { value: 2, text: "Factuur/termijn" },
                { value: 3, text: "Offerte" },
                { value: 4, text: "PVB" },
                { value: 5, text: "Keuring" },
                { value: 6, text: "Kwartaaloverleg  " },
                { value: 7, text: "Algemeen" },
                { value: 8, text: "Bestek" },
                { value: 9, text: "Storingsoverzicht" },
                { value: 10, text: "Factuur" },
                { value: 11, text: "Onderhoudscontract" },
                { value: 12, text: "Planning" },
                { value: 13, text: "Intern document" },
                { value: 14, text: "Servicerapport" },
              ],
        };
      },
}